// profile.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class ProfileGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    const status = this.authService.getProfileStatus();
    console.log("status status",status)
    if (status === 'approved' || status === 'under_verification' || status === 'resubmitted') {
      return true;
    }

    if (status === 'pending') {
      this.router.navigate(['/upload-documents']);
    } else if (status === 'rejected') {
      this.router.navigate(['/re-upload-documents']);
    } else {
      // Fallback: If empty or unknown status
      this.router.navigate(['/upload-documents']);
    }

    return false;
  }
}
